module.exports = __webpack_public_path__ + "img/ctrlaltdel.510c76f6.svg";